import { ReactNode } from 'react'
import cx from 'classnames'
import PropertyIcon from 'common/PropertyItem/PropertyIcon'
import Styles from './PropertyActions.module.scss'
import { startCase } from 'lodash'
import { ReactComponent as CheckIcon } from 'assets/icons/check16.svg'
interface Props {
  type: string
  active: boolean
  showCheckIcon?: boolean
  onMouseEnter: () => void
  onClick: () => void
  children?: ReactNode
}

const NewPropertyActionItem = ({ type, active, onMouseEnter, onClick, showCheckIcon, children }: Props) => {
  return (
    <div
      key={`property-${type}`}
      className={cx(Styles.resultRow, {
        [Styles.active]: active,
      })}
      onMouseEnter={onMouseEnter}
      onClick={onClick}
    >
      <PropertyIcon type={type} />
      <span className={Styles.resultRowTitle}>{children || startCase(type)}</span>
      {showCheckIcon && (
        <span
          className={cx(Styles.selectedTypeIcon, {
            [Styles.active]: active,
          })}
        >
          <CheckIcon />
        </span>
      )}
    </div>
  )
}

export default NewPropertyActionItem
